import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { createAction, props, on, createSelector } from '@ngrx/store';
import { EntityStoreFactory, IGenericEntityState } from '@pit/core-store';
import { IDtoResourceType } from '@pit/frontend-model';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { UtilsMisc } from '@pit/core';
import { IDtoResourceTypeEntityDataService } from '../../module.data/services/interfaces/dto.resource.type.entity.data.service.interface';

export class DtoResourceTypeStoreFactory extends EntityStoreFactory<IDtoResourceType> {

    private static _instance: DtoResourceTypeStoreFactory = null;

    public static get instance(): DtoResourceTypeStoreFactory {
        if (this._instance === null) {
            this._instance = new DtoResourceTypeStoreFactory();
        }

        return this._instance;
    }

    constructor() {
        super('DtoResourceType', 'dto.resource.type');
    }

    protected override doCreateActions(): void {
        super.doCreateActions();

        this.entityActions.add('get.by.mandator', createAction(
            'Get ResourceTypes By Mandator',
            props<{ mandator: string }>()
        ));
        this.entityActions.add('get.by.mandator.success', createAction(
            'Get ResourceTypes By Mandator Success',
            props<{ items: IDtoResourceType[] }>()
        ));
        this.entityActions.add('get.by.mandator.failure', createAction(
            'Get ResourceTypes By Mandator Failure',
            props<{ error: any }>()
        ));
    }

    protected override doCreateEffects(): void {
        super.doCreateEffects();

        this.entityEffects.add('get.by.mandator', {
            effect: (actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) => {
                return createEffect(() =>
                    actions$.pipe(
                        ofType(this.getAction('get.by.mandator')),
                        map(action => action),
                        switchMap(action =>
                            (dataServiceAccessor.getEntityDataService<IDtoResourceType>(this.dataAccessName) as IDtoResourceTypeEntityDataService)
                                .getForMandator$(action.mandator).pipe(
                                    map(items => this.getAction('get.by.mandator.success')({ items: items })),
                                    catchError(error => of(this.getAction('get.by.mandator.failure')({ error: error })))
                                )
                        )
                    )
                );
            }
        });
    }

    protected override doCreateSelectors() {
        super.doCreateSelectors();
    }

    protected override doGetReducers<S extends IGenericEntityState<IDtoResourceType>>(): any {
        const result: any = super.doGetReducers();

        result.push(
            on(
                this.getAction('get.by.mandator'),
                (state: any, { showLoadingIndicator }) => {
                    return {
                        ...state,
                        loading: ((showLoadingIndicator === true) ? true : state.loading)
                    };
                }
            )
        );
        result.push(
            on(
                this.getAction('get.by.mandator.failure'),
                (state: any) => {
                    return {
                        ...state,
                        loading: ((state.loading === true) ? false : state.loading)
                    };
                }
            )
        );
        result.push(
            on(this.getAction('get.by.mandator.success'), (state: any, { items }) => {
                const res = this.entityAdapter.setAll(items, {
                    ...state,
                    loading: false,
                    selectedItem: null
                });
                return res;
            })
        );

        return result;
    }

}
